import apiService from './apiService';

export const clientService = {
    getPaginated: (params = {}) => {
        const queryParams = {
            page: params.page || 0,
            size: params.size || 20
        };
        if (params.type) queryParams.type = params.type;
        if (params.active !== undefined) queryParams.active = params.active;
        if (params.consent !== undefined) queryParams.consent = params.consent;
        if (params.approvalStatus) queryParams.approvalStatus = params.approvalStatus;
        return apiService.get('/clients/paginated', queryParams);
    },
    searchClients: (query) => apiService.get('/clients/search', { query }),
    getActive: () => apiService.get('/clients/active'),
    getInactive: () => apiService.get('/clients/inactive'),
    getByType: (type) => apiService.get(`/clients/type/${type}`),
    getStatistics: () => apiService.get('/clients/statistics'),

    createRetail: (data) => apiService.post('/clients/retail', data),
    createCorporate: (data) => apiService.post('/clients/corporate', data),
    updateRetail: (id, data) => apiService.put(`/clients/retail/${id}`, data),
    updateCorporate: (id, data) => apiService.put(`/clients/corporate/${id}`, data),

    create: (data) => {
        const endpoint = data.clientType === 'RETAIL' ? '/clients/retail' : '/clients/corporate';
        return apiService.post(endpoint, data);
    },
    update: (id, data) => {
        const endpoint = data.clientType === 'RETAIL' ? `/clients/retail/${id}` : `/clients/corporate/${id}`;
        return apiService.put(endpoint, data);
    },

    getAll: () => apiService.get('/clients'),
    getById: (id) => apiService.get(`/clients/${id}`),
    getByCode: (code) => apiService.get(`/clients/code/${code}`),
    getByEmail: (email) => apiService.get(`/clients/email/${email}`),
    delete: (id) => apiService.delete(`/clients/${id}`),
    addProduct: (data) => apiService.post('/clients/add-product', data),
    suspend: (id, reason) => apiService.patch(`/clients/${id}/suspend`, { reason }),
    activate: (id) => apiService.patch(`/clients/${id}/activate`),
    approve: (id) => apiService.patch(`/clients/${id}/approve`),
    reject: (id, reason) => apiService.patch(`/clients/${id}/reject`, { reason }),
    getByCompany: (companyId) => apiService.get(`/clients/company/${companyId}`),
    getByCompanyAndType: (companyId, type) => apiService.get(`/clients/company/${companyId}/type/${type}`),
    getCorporateByIndustry: (industry) => apiService.get(`/clients/corporate/industry/${industry}`),
    getCompanies: (clientId) => apiService.get(`/clients/${clientId}/companies`),
    getFiltered: (filters = {}) => clientService.getPaginated(filters),

    dependants: {
        create: (data) => apiService.post('/dependants', data),
        getById: (id) => apiService.get(`/dependants/${id}`),
        getByClientId: (clientId) => apiService.get(`/dependants/client/${clientId}`),
        getActiveByClientId: (clientId) => apiService.get(`/dependants/client/${clientId}/active`),
        update: (id, data) => apiService.put(`/dependants/${id}`, data),
        delete: (id) => apiService.delete(`/dependants/${id}`),
        deactivate: (id) => apiService.patch(`/dependants/${id}/deactivate`),

        kyc: {
            upload: async (dependantId, documentType, file) => {
                const formData = new FormData();
                formData.append('file', file);
                formData.append('documentType', documentType);

                const token = localStorage.getItem('nexus_token');
                const response = await fetch(
                    `${apiService.baseURL}/dependants/${dependantId}/kyc`,
                    {
                        method: 'POST',
                        headers: {
                            'Authorization': token ? `Bearer ${token}` : ''
                        },
                        body: formData
                    }
                );

                return await apiService.handleResponse(response);
            },
            getByDependantId: (dependantId) => apiService.get(`/dependants/${dependantId}/kyc`),
            delete: (documentId) => apiService.delete(`/dependants/kyc/${documentId}`)
        }
    }
};
